module.exports = __webpack_public_path__ + "static/dog-s-found-5694d6f22884830f7396b559301bd3ed.jpg";